import { render, staticRenderFns } from "./replySection.vue?vue&type=template&id=83d898ec&scoped=true&"
import script from "./replySection.vue?vue&type=script&lang=js&"
export * from "./replySection.vue?vue&type=script&lang=js&"
import style0 from "./replySection.vue?vue&type=style&index=0&id=83d898ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d898ec",
  null
  
)

export default component.exports